import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Button, Card, Col, Form, Input, Row, Space, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import { useAppSelector } from "redux/hooks";
import { toast } from "utils/toast";

import "styles/pages/Organization/CreateOrganization.scss";

import { useCreateOrganization } from "../../../hooks/useOrganizations";
import { userDataUpdated } from "../../../store/features/user/user";
import { validateOrganizationName } from "../../../utils/validators/tenantFormValidators";

const CreateOrganization: React.FC = () => {
  const [form] = Form.useForm();
  const [selectedOption, setSelectedOption] = useState(null);
  const { userData } = useAppSelector((state) => state.entities.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const createOrgMutation = useCreateOrganization();
  const { organizationData } = useAppSelector(
    (state) => state.entities.organization,
  );

  const handleCardClick = (option: any) => {
    setSelectedOption(option);
  };

  const onFinish = (values: any) => {
    if (!selectedOption) return toast.error("Selecciona una de la opciones.");

    if (selectedOption == "1") {
      values.modules = "credit_history";
    } else {
      values.modules = "tenant";
    }

    createOrgMutation.mutate(values, {
      onSuccess: (response) => {
        const updatedUserData = {
          ...userData,
          organization_id: response.id,
          role: "Owner",
        };
        dispatch(userDataUpdated(updatedUserData));
        navigate("/");
      },
    });
  };

  useEffect(() => {
    if (organizationData) {
      navigate("/");
    }
  }, [organizationData]);

  return (
    <>
      <Title level={2}>Crea una Organización</Title>

      <Card>
        <Space direction="vertical" size="middle" style={{ display: "flex" }}>
          <Title level={5}>Selecciona una opción</Title>

          <Row gutter={[16, 16]} style={{ display: "flex" }}>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={8}
              xl={8}
              className="gutter-row"
              span={12}
            >
              <Card
                className={
                  selectedOption === "4" ? "selected-card" : "unselected-card"
                }
                onClick={() => handleCardClick("4")}
                style={{ height: "100%" }}
              >
                <h3>Inmobiliaria</h3>
                <p>
                  Soy una Inmobiliaria / dueño de inmuebles (Módulo de
                  Investigación a Inquilinos)
                </p>
              </Card>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={8}
              xl={8}
              className="gutter-row"
              span={12}
            >
              <Card
                className={
                  selectedOption === "1" ? "selected-card" : "unselected-card"
                }
                onClick={() => handleCardClick("1")}
                style={{ height: "100%" }}
              >
                <h3>Financiera</h3>
                <p>
                  Soy una financiera / arrendadora (Módulo de Historial de
                  Crédito)
                </p>
              </Card>
            </Col>
          </Row>

          <Form
            form={form}
            name="tenantForm"
            onFinish={onFinish}
            layout="vertical"
          >
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={8}
                xl={8}
                className="gutter-row"
                span={24}
              >
                <Form.Item
                  name="name"
                  label={
                    <span>
                      Nombre de tu organización{" "}
                      <Tooltip title="Si eres asesor independiente o particular, puedes poner tu nombre">
                        <InfoCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
                      </Tooltip>
                    </span>
                  }
                  rules={[
                    { required: true, message: "Name is required" },
                    { validator: validateOrganizationName },
                  ]}
                >
                  <Input
                    onChange={(e) => {
                      const upperCaseValue = e.target.value.toUpperCase();
                      form.setFieldsValue({
                        name: upperCaseValue,
                      });
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={8}
                xl={8}
                className="gutter-row"
                span={12}
              >
                <Form.Item>
                  <Button
                    type="primary"
                    ghost
                    style={{ width: "100%" }}
                    htmlType="submit"
                  >
                    Crear
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Space>
      </Card>
    </>
  );
};

export default CreateOrganization;
